/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UserImport } from './routes/user'
import { Route as SuccessPageImport } from './routes/successPage'
import { Route as RegisterImport } from './routes/register'
import { Route as RcheckoutImport } from './routes/rcheckout'
import { Route as PrImport } from './routes/pr'
import { Route as PlanImport } from './routes/plan'
import { Route as MenuImport } from './routes/menu'
import { Route as LoginPageImport } from './routes/loginPage'
import { Route as LiImport } from './routes/li'
import { Route as HomeImport } from './routes/home'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as AIAssistantImport } from './routes/AIAssistant'
import { Route as IndexImport } from './routes/index'
import { Route as UserPreferencesImport } from './routes/user/preferences'
import { Route as RegisterUserDataImport } from './routes/register/user-data'
import { Route as RegisterSuccessImport } from './routes/register/success'
import { Route as RegisterSubscriptionsImport } from './routes/register/subscriptions'
import { Route as RegisterShippingMethodsImport } from './routes/register/shipping-methods'
import { Route as RegisterShippingFrecuencyImport } from './routes/register/shipping-frecuency'
import { Route as RegisterConfirmationImport } from './routes/register/confirmation'
import { Route as RReferralCodeImport } from './routes/r/$referralCode'
import { Route as UserSubscriptionEditImport } from './routes/user/subscription/edit'
import { Route as UserShippingEditImport } from './routes/user/shipping/edit'

// Create Virtual Routes

const LogoutIndexLazyImport = createFileRoute('/logout/')()
const LoginIndexLazyImport = createFileRoute('/login/')()
const RegisternewBetaLazyImport = createFileRoute('/register_new/beta')()
const partnershipsPluxeeLazyImport = createFileRoute('/(partnerships)/pluxee')()
const partnershipsCyberLazyImport = createFileRoute('/(partnerships)/cyber')()
const partnershipsActivacionesLazyImport = createFileRoute(
  '/(partnerships)/activaciones',
)()
const UserSubscriptionIndexLazyImport = createFileRoute('/user/subscription/')()
const UserStoreIndexLazyImport = createFileRoute('/user/store/')()
const UserReferralIndexLazyImport = createFileRoute('/user/referral/')()
const UserPaymentMethodsIndexLazyImport = createFileRoute(
  '/user/payment-methods/',
)()
const UserOrdersIndexLazyImport = createFileRoute('/user/orders/')()
const UserHomeIndexLazyImport = createFileRoute('/user/home/')()
const UserDiscountsIndexLazyImport = createFileRoute('/user/discounts/')()
const UserAccountIndexLazyImport = createFileRoute('/user/account/')()
const partnershipsTarjetaMiVitaIndexLazyImport = createFileRoute(
  '/(partnerships)/tarjeta-mi-vita/',
)()
const partnershipsLoBarnecheaIndexLazyImport = createFileRoute(
  '/(partnerships)/lo-barnechea/',
)()
const partnershipsFenUchileIndexLazyImport = createFileRoute(
  '/(partnerships)/fen-uchile/',
)()
const partnershipsEntelIndexLazyImport = createFileRoute(
  '/(partnerships)/entel/',
)()
const partnershipsEnergyClubIndexLazyImport = createFileRoute(
  '/(partnerships)/energy-club/',
)()
const partnershipsCajaLosAndesIndexLazyImport = createFileRoute(
  '/(partnerships)/caja-los-andes/',
)()
const informationTermsAndConditionsIndexLazyImport = createFileRoute(
  '/(information)/terms-and-conditions/',
)()
const informationPrivacyPolicyIndexLazyImport = createFileRoute(
  '/(information)/privacy-policy/',
)()
const UserSubscriptionBoxIndexLazyImport = createFileRoute(
  '/user/subscription/box/',
)()
const UserSubscriptionBoxEditLazyImport = createFileRoute(
  '/user/subscription/box/edit',
)()

// Create/Update Routes

const UserRoute = UserImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => rootRoute,
} as any)

const SuccessPageRoute = SuccessPageImport.update({
  id: '/successPage',
  path: '/successPage',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const RcheckoutRoute = RcheckoutImport.update({
  id: '/rcheckout',
  path: '/rcheckout',
  getParentRoute: () => rootRoute,
} as any)

const PrRoute = PrImport.update({
  id: '/pr',
  path: '/pr',
  getParentRoute: () => rootRoute,
} as any)

const PlanRoute = PlanImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => rootRoute,
} as any)

const MenuRoute = MenuImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => rootRoute,
} as any)

const LoginPageRoute = LoginPageImport.update({
  id: '/loginPage',
  path: '/loginPage',
  getParentRoute: () => rootRoute,
} as any)

const LiRoute = LiImport.update({
  id: '/li',
  path: '/li',
  getParentRoute: () => rootRoute,
} as any)

const HomeRoute = HomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AIAssistantRoute = AIAssistantImport.update({
  id: '/AIAssistant',
  path: '/AIAssistant',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const LogoutIndexLazyRoute = LogoutIndexLazyImport.update({
  id: '/logout/',
  path: '/logout/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/logout/index.lazy').then((d) => d.Route))

const LoginIndexLazyRoute = LoginIndexLazyImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/login/index.lazy').then((d) => d.Route))

const RegisternewBetaLazyRoute = RegisternewBetaLazyImport.update({
  id: '/register_new/beta',
  path: '/register_new/beta',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/register_new/beta.lazy').then((d) => d.Route),
)

const partnershipsPluxeeLazyRoute = partnershipsPluxeeLazyImport
  .update({
    id: '/(partnerships)/pluxee',
    path: '/pluxee',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import('./routes/(partnerships)/pluxee.lazy').then((d) => d.Route),
  )

const partnershipsCyberLazyRoute = partnershipsCyberLazyImport
  .update({
    id: '/(partnerships)/cyber',
    path: '/cyber',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import('./routes/(partnerships)/cyber.lazy').then((d) => d.Route))

const partnershipsActivacionesLazyRoute = partnershipsActivacionesLazyImport
  .update({
    id: '/(partnerships)/activaciones',
    path: '/activaciones',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import('./routes/(partnerships)/activaciones.lazy').then((d) => d.Route),
  )

const UserPreferencesRoute = UserPreferencesImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => UserRoute,
} as any)

const RegisterUserDataRoute = RegisterUserDataImport.update({
  id: '/user-data',
  path: '/user-data',
  getParentRoute: () => RegisterRoute,
} as any)

const RegisterSuccessRoute = RegisterSuccessImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => RegisterRoute,
} as any)

const RegisterSubscriptionsRoute = RegisterSubscriptionsImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => RegisterRoute,
} as any)

const RegisterShippingMethodsRoute = RegisterShippingMethodsImport.update({
  id: '/shipping-methods',
  path: '/shipping-methods',
  getParentRoute: () => RegisterRoute,
} as any)

const RegisterShippingFrecuencyRoute = RegisterShippingFrecuencyImport.update({
  id: '/shipping-frecuency',
  path: '/shipping-frecuency',
  getParentRoute: () => RegisterRoute,
} as any)

const RegisterConfirmationRoute = RegisterConfirmationImport.update({
  id: '/confirmation',
  path: '/confirmation',
  getParentRoute: () => RegisterRoute,
} as any)

const RReferralCodeRoute = RReferralCodeImport.update({
  id: '/r/$referralCode',
  path: '/r/$referralCode',
  getParentRoute: () => rootRoute,
} as any)

const UserSubscriptionIndexLazyRoute = UserSubscriptionIndexLazyImport.update({
  id: '/subscription/',
  path: '/subscription/',
  getParentRoute: () => UserRoute,
} as any).lazy(() =>
  import('./routes/user/subscription/index.lazy').then((d) => d.Route),
)

const UserStoreIndexLazyRoute = UserStoreIndexLazyImport.update({
  id: '/store/',
  path: '/store/',
  getParentRoute: () => UserRoute,
} as any).lazy(() =>
  import('./routes/user/store/index.lazy').then((d) => d.Route),
)

const UserReferralIndexLazyRoute = UserReferralIndexLazyImport.update({
  id: '/referral/',
  path: '/referral/',
  getParentRoute: () => UserRoute,
} as any).lazy(() =>
  import('./routes/user/referral/index.lazy').then((d) => d.Route),
)

const UserPaymentMethodsIndexLazyRoute =
  UserPaymentMethodsIndexLazyImport.update({
    id: '/payment-methods/',
    path: '/payment-methods/',
    getParentRoute: () => UserRoute,
  } as any).lazy(() =>
    import('./routes/user/payment-methods/index.lazy').then((d) => d.Route),
  )

const UserOrdersIndexLazyRoute = UserOrdersIndexLazyImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => UserRoute,
} as any).lazy(() =>
  import('./routes/user/orders/index.lazy').then((d) => d.Route),
)

const UserHomeIndexLazyRoute = UserHomeIndexLazyImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => UserRoute,
} as any).lazy(() =>
  import('./routes/user/home/index.lazy').then((d) => d.Route),
)

const UserDiscountsIndexLazyRoute = UserDiscountsIndexLazyImport.update({
  id: '/discounts/',
  path: '/discounts/',
  getParentRoute: () => UserRoute,
} as any).lazy(() =>
  import('./routes/user/discounts/index.lazy').then((d) => d.Route),
)

const UserAccountIndexLazyRoute = UserAccountIndexLazyImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => UserRoute,
} as any).lazy(() =>
  import('./routes/user/account/index.lazy').then((d) => d.Route),
)

const partnershipsTarjetaMiVitaIndexLazyRoute =
  partnershipsTarjetaMiVitaIndexLazyImport
    .update({
      id: '/(partnerships)/tarjeta-mi-vita/',
      path: '/tarjeta-mi-vita/',
      getParentRoute: () => rootRoute,
    } as any)
    .lazy(() =>
      import('./routes/(partnerships)/tarjeta-mi-vita/index.lazy').then(
        (d) => d.Route,
      ),
    )

const partnershipsLoBarnecheaIndexLazyRoute =
  partnershipsLoBarnecheaIndexLazyImport
    .update({
      id: '/(partnerships)/lo-barnechea/',
      path: '/lo-barnechea/',
      getParentRoute: () => rootRoute,
    } as any)
    .lazy(() =>
      import('./routes/(partnerships)/lo-barnechea/index.lazy').then(
        (d) => d.Route,
      ),
    )

const partnershipsFenUchileIndexLazyRoute = partnershipsFenUchileIndexLazyImport
  .update({
    id: '/(partnerships)/fen-uchile/',
    path: '/fen-uchile/',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import('./routes/(partnerships)/fen-uchile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const partnershipsEntelIndexLazyRoute = partnershipsEntelIndexLazyImport
  .update({
    id: '/(partnerships)/entel/',
    path: '/entel/',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import('./routes/(partnerships)/entel/index.lazy').then((d) => d.Route),
  )

const partnershipsEnergyClubIndexLazyRoute =
  partnershipsEnergyClubIndexLazyImport
    .update({
      id: '/(partnerships)/energy-club/',
      path: '/energy-club/',
      getParentRoute: () => rootRoute,
    } as any)
    .lazy(() =>
      import('./routes/(partnerships)/energy-club/index.lazy').then(
        (d) => d.Route,
      ),
    )

const partnershipsCajaLosAndesIndexLazyRoute =
  partnershipsCajaLosAndesIndexLazyImport
    .update({
      id: '/(partnerships)/caja-los-andes/',
      path: '/caja-los-andes/',
      getParentRoute: () => rootRoute,
    } as any)
    .lazy(() =>
      import('./routes/(partnerships)/caja-los-andes/index.lazy').then(
        (d) => d.Route,
      ),
    )

const informationTermsAndConditionsIndexLazyRoute =
  informationTermsAndConditionsIndexLazyImport
    .update({
      id: '/(information)/terms-and-conditions/',
      path: '/terms-and-conditions/',
      getParentRoute: () => rootRoute,
    } as any)
    .lazy(() =>
      import('./routes/(information)/terms-and-conditions/index.lazy').then(
        (d) => d.Route,
      ),
    )

const informationPrivacyPolicyIndexLazyRoute =
  informationPrivacyPolicyIndexLazyImport
    .update({
      id: '/(information)/privacy-policy/',
      path: '/privacy-policy/',
      getParentRoute: () => rootRoute,
    } as any)
    .lazy(() =>
      import('./routes/(information)/privacy-policy/index.lazy').then(
        (d) => d.Route,
      ),
    )

const UserSubscriptionEditRoute = UserSubscriptionEditImport.update({
  id: '/subscription/edit',
  path: '/subscription/edit',
  getParentRoute: () => UserRoute,
} as any)

const UserShippingEditRoute = UserShippingEditImport.update({
  id: '/shipping/edit',
  path: '/shipping/edit',
  getParentRoute: () => UserRoute,
} as any)

const UserSubscriptionBoxIndexLazyRoute =
  UserSubscriptionBoxIndexLazyImport.update({
    id: '/subscription/box/',
    path: '/subscription/box/',
    getParentRoute: () => UserRoute,
  } as any).lazy(() =>
    import('./routes/user/subscription/box/index.lazy').then((d) => d.Route),
  )

const UserSubscriptionBoxEditLazyRoute =
  UserSubscriptionBoxEditLazyImport.update({
    id: '/subscription/box/edit',
    path: '/subscription/box/edit',
    getParentRoute: () => UserRoute,
  } as any).lazy(() =>
    import('./routes/user/subscription/box/edit.lazy').then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/AIAssistant': {
      id: '/AIAssistant'
      path: '/AIAssistant'
      fullPath: '/AIAssistant'
      preLoaderRoute: typeof AIAssistantImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeImport
      parentRoute: typeof rootRoute
    }
    '/li': {
      id: '/li'
      path: '/li'
      fullPath: '/li'
      preLoaderRoute: typeof LiImport
      parentRoute: typeof rootRoute
    }
    '/loginPage': {
      id: '/loginPage'
      path: '/loginPage'
      fullPath: '/loginPage'
      preLoaderRoute: typeof LoginPageImport
      parentRoute: typeof rootRoute
    }
    '/menu': {
      id: '/menu'
      path: '/menu'
      fullPath: '/menu'
      preLoaderRoute: typeof MenuImport
      parentRoute: typeof rootRoute
    }
    '/plan': {
      id: '/plan'
      path: '/plan'
      fullPath: '/plan'
      preLoaderRoute: typeof PlanImport
      parentRoute: typeof rootRoute
    }
    '/pr': {
      id: '/pr'
      path: '/pr'
      fullPath: '/pr'
      preLoaderRoute: typeof PrImport
      parentRoute: typeof rootRoute
    }
    '/rcheckout': {
      id: '/rcheckout'
      path: '/rcheckout'
      fullPath: '/rcheckout'
      preLoaderRoute: typeof RcheckoutImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/successPage': {
      id: '/successPage'
      path: '/successPage'
      fullPath: '/successPage'
      preLoaderRoute: typeof SuccessPageImport
      parentRoute: typeof rootRoute
    }
    '/user': {
      id: '/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserImport
      parentRoute: typeof rootRoute
    }
    '/r/$referralCode': {
      id: '/r/$referralCode'
      path: '/r/$referralCode'
      fullPath: '/r/$referralCode'
      preLoaderRoute: typeof RReferralCodeImport
      parentRoute: typeof rootRoute
    }
    '/register/confirmation': {
      id: '/register/confirmation'
      path: '/confirmation'
      fullPath: '/register/confirmation'
      preLoaderRoute: typeof RegisterConfirmationImport
      parentRoute: typeof RegisterImport
    }
    '/register/shipping-frecuency': {
      id: '/register/shipping-frecuency'
      path: '/shipping-frecuency'
      fullPath: '/register/shipping-frecuency'
      preLoaderRoute: typeof RegisterShippingFrecuencyImport
      parentRoute: typeof RegisterImport
    }
    '/register/shipping-methods': {
      id: '/register/shipping-methods'
      path: '/shipping-methods'
      fullPath: '/register/shipping-methods'
      preLoaderRoute: typeof RegisterShippingMethodsImport
      parentRoute: typeof RegisterImport
    }
    '/register/subscriptions': {
      id: '/register/subscriptions'
      path: '/subscriptions'
      fullPath: '/register/subscriptions'
      preLoaderRoute: typeof RegisterSubscriptionsImport
      parentRoute: typeof RegisterImport
    }
    '/register/success': {
      id: '/register/success'
      path: '/success'
      fullPath: '/register/success'
      preLoaderRoute: typeof RegisterSuccessImport
      parentRoute: typeof RegisterImport
    }
    '/register/user-data': {
      id: '/register/user-data'
      path: '/user-data'
      fullPath: '/register/user-data'
      preLoaderRoute: typeof RegisterUserDataImport
      parentRoute: typeof RegisterImport
    }
    '/user/preferences': {
      id: '/user/preferences'
      path: '/preferences'
      fullPath: '/user/preferences'
      preLoaderRoute: typeof UserPreferencesImport
      parentRoute: typeof UserImport
    }
    '/(partnerships)/activaciones': {
      id: '/(partnerships)/activaciones'
      path: '/activaciones'
      fullPath: '/activaciones'
      preLoaderRoute: typeof partnershipsActivacionesLazyImport
      parentRoute: typeof rootRoute
    }
    '/(partnerships)/cyber': {
      id: '/(partnerships)/cyber'
      path: '/cyber'
      fullPath: '/cyber'
      preLoaderRoute: typeof partnershipsCyberLazyImport
      parentRoute: typeof rootRoute
    }
    '/(partnerships)/pluxee': {
      id: '/(partnerships)/pluxee'
      path: '/pluxee'
      fullPath: '/pluxee'
      preLoaderRoute: typeof partnershipsPluxeeLazyImport
      parentRoute: typeof rootRoute
    }
    '/register_new/beta': {
      id: '/register_new/beta'
      path: '/register_new/beta'
      fullPath: '/register_new/beta'
      preLoaderRoute: typeof RegisternewBetaLazyImport
      parentRoute: typeof rootRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/logout/': {
      id: '/logout/'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/user/shipping/edit': {
      id: '/user/shipping/edit'
      path: '/shipping/edit'
      fullPath: '/user/shipping/edit'
      preLoaderRoute: typeof UserShippingEditImport
      parentRoute: typeof UserImport
    }
    '/user/subscription/edit': {
      id: '/user/subscription/edit'
      path: '/subscription/edit'
      fullPath: '/user/subscription/edit'
      preLoaderRoute: typeof UserSubscriptionEditImport
      parentRoute: typeof UserImport
    }
    '/(information)/privacy-policy/': {
      id: '/(information)/privacy-policy/'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof informationPrivacyPolicyIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/(information)/terms-and-conditions/': {
      id: '/(information)/terms-and-conditions/'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof informationTermsAndConditionsIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/(partnerships)/caja-los-andes/': {
      id: '/(partnerships)/caja-los-andes/'
      path: '/caja-los-andes'
      fullPath: '/caja-los-andes'
      preLoaderRoute: typeof partnershipsCajaLosAndesIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/(partnerships)/energy-club/': {
      id: '/(partnerships)/energy-club/'
      path: '/energy-club'
      fullPath: '/energy-club'
      preLoaderRoute: typeof partnershipsEnergyClubIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/(partnerships)/entel/': {
      id: '/(partnerships)/entel/'
      path: '/entel'
      fullPath: '/entel'
      preLoaderRoute: typeof partnershipsEntelIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/(partnerships)/fen-uchile/': {
      id: '/(partnerships)/fen-uchile/'
      path: '/fen-uchile'
      fullPath: '/fen-uchile'
      preLoaderRoute: typeof partnershipsFenUchileIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/(partnerships)/lo-barnechea/': {
      id: '/(partnerships)/lo-barnechea/'
      path: '/lo-barnechea'
      fullPath: '/lo-barnechea'
      preLoaderRoute: typeof partnershipsLoBarnecheaIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/(partnerships)/tarjeta-mi-vita/': {
      id: '/(partnerships)/tarjeta-mi-vita/'
      path: '/tarjeta-mi-vita'
      fullPath: '/tarjeta-mi-vita'
      preLoaderRoute: typeof partnershipsTarjetaMiVitaIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/user/account/': {
      id: '/user/account/'
      path: '/account'
      fullPath: '/user/account'
      preLoaderRoute: typeof UserAccountIndexLazyImport
      parentRoute: typeof UserImport
    }
    '/user/discounts/': {
      id: '/user/discounts/'
      path: '/discounts'
      fullPath: '/user/discounts'
      preLoaderRoute: typeof UserDiscountsIndexLazyImport
      parentRoute: typeof UserImport
    }
    '/user/home/': {
      id: '/user/home/'
      path: '/home'
      fullPath: '/user/home'
      preLoaderRoute: typeof UserHomeIndexLazyImport
      parentRoute: typeof UserImport
    }
    '/user/orders/': {
      id: '/user/orders/'
      path: '/orders'
      fullPath: '/user/orders'
      preLoaderRoute: typeof UserOrdersIndexLazyImport
      parentRoute: typeof UserImport
    }
    '/user/payment-methods/': {
      id: '/user/payment-methods/'
      path: '/payment-methods'
      fullPath: '/user/payment-methods'
      preLoaderRoute: typeof UserPaymentMethodsIndexLazyImport
      parentRoute: typeof UserImport
    }
    '/user/referral/': {
      id: '/user/referral/'
      path: '/referral'
      fullPath: '/user/referral'
      preLoaderRoute: typeof UserReferralIndexLazyImport
      parentRoute: typeof UserImport
    }
    '/user/store/': {
      id: '/user/store/'
      path: '/store'
      fullPath: '/user/store'
      preLoaderRoute: typeof UserStoreIndexLazyImport
      parentRoute: typeof UserImport
    }
    '/user/subscription/': {
      id: '/user/subscription/'
      path: '/subscription'
      fullPath: '/user/subscription'
      preLoaderRoute: typeof UserSubscriptionIndexLazyImport
      parentRoute: typeof UserImport
    }
    '/user/subscription/box/edit': {
      id: '/user/subscription/box/edit'
      path: '/subscription/box/edit'
      fullPath: '/user/subscription/box/edit'
      preLoaderRoute: typeof UserSubscriptionBoxEditLazyImport
      parentRoute: typeof UserImport
    }
    '/user/subscription/box/': {
      id: '/user/subscription/box/'
      path: '/subscription/box'
      fullPath: '/user/subscription/box'
      preLoaderRoute: typeof UserSubscriptionBoxIndexLazyImport
      parentRoute: typeof UserImport
    }
  }
}

// Create and export the route tree

interface RegisterRouteChildren {
  RegisterConfirmationRoute: typeof RegisterConfirmationRoute
  RegisterShippingFrecuencyRoute: typeof RegisterShippingFrecuencyRoute
  RegisterShippingMethodsRoute: typeof RegisterShippingMethodsRoute
  RegisterSubscriptionsRoute: typeof RegisterSubscriptionsRoute
  RegisterSuccessRoute: typeof RegisterSuccessRoute
  RegisterUserDataRoute: typeof RegisterUserDataRoute
}

const RegisterRouteChildren: RegisterRouteChildren = {
  RegisterConfirmationRoute: RegisterConfirmationRoute,
  RegisterShippingFrecuencyRoute: RegisterShippingFrecuencyRoute,
  RegisterShippingMethodsRoute: RegisterShippingMethodsRoute,
  RegisterSubscriptionsRoute: RegisterSubscriptionsRoute,
  RegisterSuccessRoute: RegisterSuccessRoute,
  RegisterUserDataRoute: RegisterUserDataRoute,
}

const RegisterRouteWithChildren = RegisterRoute._addFileChildren(
  RegisterRouteChildren,
)

interface UserRouteChildren {
  UserPreferencesRoute: typeof UserPreferencesRoute
  UserShippingEditRoute: typeof UserShippingEditRoute
  UserSubscriptionEditRoute: typeof UserSubscriptionEditRoute
  UserAccountIndexLazyRoute: typeof UserAccountIndexLazyRoute
  UserDiscountsIndexLazyRoute: typeof UserDiscountsIndexLazyRoute
  UserHomeIndexLazyRoute: typeof UserHomeIndexLazyRoute
  UserOrdersIndexLazyRoute: typeof UserOrdersIndexLazyRoute
  UserPaymentMethodsIndexLazyRoute: typeof UserPaymentMethodsIndexLazyRoute
  UserReferralIndexLazyRoute: typeof UserReferralIndexLazyRoute
  UserStoreIndexLazyRoute: typeof UserStoreIndexLazyRoute
  UserSubscriptionIndexLazyRoute: typeof UserSubscriptionIndexLazyRoute
  UserSubscriptionBoxEditLazyRoute: typeof UserSubscriptionBoxEditLazyRoute
  UserSubscriptionBoxIndexLazyRoute: typeof UserSubscriptionBoxIndexLazyRoute
}

const UserRouteChildren: UserRouteChildren = {
  UserPreferencesRoute: UserPreferencesRoute,
  UserShippingEditRoute: UserShippingEditRoute,
  UserSubscriptionEditRoute: UserSubscriptionEditRoute,
  UserAccountIndexLazyRoute: UserAccountIndexLazyRoute,
  UserDiscountsIndexLazyRoute: UserDiscountsIndexLazyRoute,
  UserHomeIndexLazyRoute: UserHomeIndexLazyRoute,
  UserOrdersIndexLazyRoute: UserOrdersIndexLazyRoute,
  UserPaymentMethodsIndexLazyRoute: UserPaymentMethodsIndexLazyRoute,
  UserReferralIndexLazyRoute: UserReferralIndexLazyRoute,
  UserStoreIndexLazyRoute: UserStoreIndexLazyRoute,
  UserSubscriptionIndexLazyRoute: UserSubscriptionIndexLazyRoute,
  UserSubscriptionBoxEditLazyRoute: UserSubscriptionBoxEditLazyRoute,
  UserSubscriptionBoxIndexLazyRoute: UserSubscriptionBoxIndexLazyRoute,
}

const UserRouteWithChildren = UserRoute._addFileChildren(UserRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/AIAssistant': typeof AIAssistantRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/home': typeof HomeRoute
  '/li': typeof LiRoute
  '/loginPage': typeof LoginPageRoute
  '/menu': typeof MenuRoute
  '/plan': typeof PlanRoute
  '/pr': typeof PrRoute
  '/rcheckout': typeof RcheckoutRoute
  '/register': typeof RegisterRouteWithChildren
  '/successPage': typeof SuccessPageRoute
  '/user': typeof UserRouteWithChildren
  '/r/$referralCode': typeof RReferralCodeRoute
  '/register/confirmation': typeof RegisterConfirmationRoute
  '/register/shipping-frecuency': typeof RegisterShippingFrecuencyRoute
  '/register/shipping-methods': typeof RegisterShippingMethodsRoute
  '/register/subscriptions': typeof RegisterSubscriptionsRoute
  '/register/success': typeof RegisterSuccessRoute
  '/register/user-data': typeof RegisterUserDataRoute
  '/user/preferences': typeof UserPreferencesRoute
  '/activaciones': typeof partnershipsActivacionesLazyRoute
  '/cyber': typeof partnershipsCyberLazyRoute
  '/pluxee': typeof partnershipsPluxeeLazyRoute
  '/register_new/beta': typeof RegisternewBetaLazyRoute
  '/login': typeof LoginIndexLazyRoute
  '/logout': typeof LogoutIndexLazyRoute
  '/user/shipping/edit': typeof UserShippingEditRoute
  '/user/subscription/edit': typeof UserSubscriptionEditRoute
  '/privacy-policy': typeof informationPrivacyPolicyIndexLazyRoute
  '/terms-and-conditions': typeof informationTermsAndConditionsIndexLazyRoute
  '/caja-los-andes': typeof partnershipsCajaLosAndesIndexLazyRoute
  '/energy-club': typeof partnershipsEnergyClubIndexLazyRoute
  '/entel': typeof partnershipsEntelIndexLazyRoute
  '/fen-uchile': typeof partnershipsFenUchileIndexLazyRoute
  '/lo-barnechea': typeof partnershipsLoBarnecheaIndexLazyRoute
  '/tarjeta-mi-vita': typeof partnershipsTarjetaMiVitaIndexLazyRoute
  '/user/account': typeof UserAccountIndexLazyRoute
  '/user/discounts': typeof UserDiscountsIndexLazyRoute
  '/user/home': typeof UserHomeIndexLazyRoute
  '/user/orders': typeof UserOrdersIndexLazyRoute
  '/user/payment-methods': typeof UserPaymentMethodsIndexLazyRoute
  '/user/referral': typeof UserReferralIndexLazyRoute
  '/user/store': typeof UserStoreIndexLazyRoute
  '/user/subscription': typeof UserSubscriptionIndexLazyRoute
  '/user/subscription/box/edit': typeof UserSubscriptionBoxEditLazyRoute
  '/user/subscription/box': typeof UserSubscriptionBoxIndexLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/AIAssistant': typeof AIAssistantRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/home': typeof HomeRoute
  '/li': typeof LiRoute
  '/loginPage': typeof LoginPageRoute
  '/menu': typeof MenuRoute
  '/plan': typeof PlanRoute
  '/pr': typeof PrRoute
  '/rcheckout': typeof RcheckoutRoute
  '/register': typeof RegisterRouteWithChildren
  '/successPage': typeof SuccessPageRoute
  '/user': typeof UserRouteWithChildren
  '/r/$referralCode': typeof RReferralCodeRoute
  '/register/confirmation': typeof RegisterConfirmationRoute
  '/register/shipping-frecuency': typeof RegisterShippingFrecuencyRoute
  '/register/shipping-methods': typeof RegisterShippingMethodsRoute
  '/register/subscriptions': typeof RegisterSubscriptionsRoute
  '/register/success': typeof RegisterSuccessRoute
  '/register/user-data': typeof RegisterUserDataRoute
  '/user/preferences': typeof UserPreferencesRoute
  '/activaciones': typeof partnershipsActivacionesLazyRoute
  '/cyber': typeof partnershipsCyberLazyRoute
  '/pluxee': typeof partnershipsPluxeeLazyRoute
  '/register_new/beta': typeof RegisternewBetaLazyRoute
  '/login': typeof LoginIndexLazyRoute
  '/logout': typeof LogoutIndexLazyRoute
  '/user/shipping/edit': typeof UserShippingEditRoute
  '/user/subscription/edit': typeof UserSubscriptionEditRoute
  '/privacy-policy': typeof informationPrivacyPolicyIndexLazyRoute
  '/terms-and-conditions': typeof informationTermsAndConditionsIndexLazyRoute
  '/caja-los-andes': typeof partnershipsCajaLosAndesIndexLazyRoute
  '/energy-club': typeof partnershipsEnergyClubIndexLazyRoute
  '/entel': typeof partnershipsEntelIndexLazyRoute
  '/fen-uchile': typeof partnershipsFenUchileIndexLazyRoute
  '/lo-barnechea': typeof partnershipsLoBarnecheaIndexLazyRoute
  '/tarjeta-mi-vita': typeof partnershipsTarjetaMiVitaIndexLazyRoute
  '/user/account': typeof UserAccountIndexLazyRoute
  '/user/discounts': typeof UserDiscountsIndexLazyRoute
  '/user/home': typeof UserHomeIndexLazyRoute
  '/user/orders': typeof UserOrdersIndexLazyRoute
  '/user/payment-methods': typeof UserPaymentMethodsIndexLazyRoute
  '/user/referral': typeof UserReferralIndexLazyRoute
  '/user/store': typeof UserStoreIndexLazyRoute
  '/user/subscription': typeof UserSubscriptionIndexLazyRoute
  '/user/subscription/box/edit': typeof UserSubscriptionBoxEditLazyRoute
  '/user/subscription/box': typeof UserSubscriptionBoxIndexLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/AIAssistant': typeof AIAssistantRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/home': typeof HomeRoute
  '/li': typeof LiRoute
  '/loginPage': typeof LoginPageRoute
  '/menu': typeof MenuRoute
  '/plan': typeof PlanRoute
  '/pr': typeof PrRoute
  '/rcheckout': typeof RcheckoutRoute
  '/register': typeof RegisterRouteWithChildren
  '/successPage': typeof SuccessPageRoute
  '/user': typeof UserRouteWithChildren
  '/r/$referralCode': typeof RReferralCodeRoute
  '/register/confirmation': typeof RegisterConfirmationRoute
  '/register/shipping-frecuency': typeof RegisterShippingFrecuencyRoute
  '/register/shipping-methods': typeof RegisterShippingMethodsRoute
  '/register/subscriptions': typeof RegisterSubscriptionsRoute
  '/register/success': typeof RegisterSuccessRoute
  '/register/user-data': typeof RegisterUserDataRoute
  '/user/preferences': typeof UserPreferencesRoute
  '/(partnerships)/activaciones': typeof partnershipsActivacionesLazyRoute
  '/(partnerships)/cyber': typeof partnershipsCyberLazyRoute
  '/(partnerships)/pluxee': typeof partnershipsPluxeeLazyRoute
  '/register_new/beta': typeof RegisternewBetaLazyRoute
  '/login/': typeof LoginIndexLazyRoute
  '/logout/': typeof LogoutIndexLazyRoute
  '/user/shipping/edit': typeof UserShippingEditRoute
  '/user/subscription/edit': typeof UserSubscriptionEditRoute
  '/(information)/privacy-policy/': typeof informationPrivacyPolicyIndexLazyRoute
  '/(information)/terms-and-conditions/': typeof informationTermsAndConditionsIndexLazyRoute
  '/(partnerships)/caja-los-andes/': typeof partnershipsCajaLosAndesIndexLazyRoute
  '/(partnerships)/energy-club/': typeof partnershipsEnergyClubIndexLazyRoute
  '/(partnerships)/entel/': typeof partnershipsEntelIndexLazyRoute
  '/(partnerships)/fen-uchile/': typeof partnershipsFenUchileIndexLazyRoute
  '/(partnerships)/lo-barnechea/': typeof partnershipsLoBarnecheaIndexLazyRoute
  '/(partnerships)/tarjeta-mi-vita/': typeof partnershipsTarjetaMiVitaIndexLazyRoute
  '/user/account/': typeof UserAccountIndexLazyRoute
  '/user/discounts/': typeof UserDiscountsIndexLazyRoute
  '/user/home/': typeof UserHomeIndexLazyRoute
  '/user/orders/': typeof UserOrdersIndexLazyRoute
  '/user/payment-methods/': typeof UserPaymentMethodsIndexLazyRoute
  '/user/referral/': typeof UserReferralIndexLazyRoute
  '/user/store/': typeof UserStoreIndexLazyRoute
  '/user/subscription/': typeof UserSubscriptionIndexLazyRoute
  '/user/subscription/box/edit': typeof UserSubscriptionBoxEditLazyRoute
  '/user/subscription/box/': typeof UserSubscriptionBoxIndexLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/AIAssistant'
    | '/forgot-password'
    | '/home'
    | '/li'
    | '/loginPage'
    | '/menu'
    | '/plan'
    | '/pr'
    | '/rcheckout'
    | '/register'
    | '/successPage'
    | '/user'
    | '/r/$referralCode'
    | '/register/confirmation'
    | '/register/shipping-frecuency'
    | '/register/shipping-methods'
    | '/register/subscriptions'
    | '/register/success'
    | '/register/user-data'
    | '/user/preferences'
    | '/activaciones'
    | '/cyber'
    | '/pluxee'
    | '/register_new/beta'
    | '/login'
    | '/logout'
    | '/user/shipping/edit'
    | '/user/subscription/edit'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/caja-los-andes'
    | '/energy-club'
    | '/entel'
    | '/fen-uchile'
    | '/lo-barnechea'
    | '/tarjeta-mi-vita'
    | '/user/account'
    | '/user/discounts'
    | '/user/home'
    | '/user/orders'
    | '/user/payment-methods'
    | '/user/referral'
    | '/user/store'
    | '/user/subscription'
    | '/user/subscription/box/edit'
    | '/user/subscription/box'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/AIAssistant'
    | '/forgot-password'
    | '/home'
    | '/li'
    | '/loginPage'
    | '/menu'
    | '/plan'
    | '/pr'
    | '/rcheckout'
    | '/register'
    | '/successPage'
    | '/user'
    | '/r/$referralCode'
    | '/register/confirmation'
    | '/register/shipping-frecuency'
    | '/register/shipping-methods'
    | '/register/subscriptions'
    | '/register/success'
    | '/register/user-data'
    | '/user/preferences'
    | '/activaciones'
    | '/cyber'
    | '/pluxee'
    | '/register_new/beta'
    | '/login'
    | '/logout'
    | '/user/shipping/edit'
    | '/user/subscription/edit'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/caja-los-andes'
    | '/energy-club'
    | '/entel'
    | '/fen-uchile'
    | '/lo-barnechea'
    | '/tarjeta-mi-vita'
    | '/user/account'
    | '/user/discounts'
    | '/user/home'
    | '/user/orders'
    | '/user/payment-methods'
    | '/user/referral'
    | '/user/store'
    | '/user/subscription'
    | '/user/subscription/box/edit'
    | '/user/subscription/box'
  id:
    | '__root__'
    | '/'
    | '/AIAssistant'
    | '/forgot-password'
    | '/home'
    | '/li'
    | '/loginPage'
    | '/menu'
    | '/plan'
    | '/pr'
    | '/rcheckout'
    | '/register'
    | '/successPage'
    | '/user'
    | '/r/$referralCode'
    | '/register/confirmation'
    | '/register/shipping-frecuency'
    | '/register/shipping-methods'
    | '/register/subscriptions'
    | '/register/success'
    | '/register/user-data'
    | '/user/preferences'
    | '/(partnerships)/activaciones'
    | '/(partnerships)/cyber'
    | '/(partnerships)/pluxee'
    | '/register_new/beta'
    | '/login/'
    | '/logout/'
    | '/user/shipping/edit'
    | '/user/subscription/edit'
    | '/(information)/privacy-policy/'
    | '/(information)/terms-and-conditions/'
    | '/(partnerships)/caja-los-andes/'
    | '/(partnerships)/energy-club/'
    | '/(partnerships)/entel/'
    | '/(partnerships)/fen-uchile/'
    | '/(partnerships)/lo-barnechea/'
    | '/(partnerships)/tarjeta-mi-vita/'
    | '/user/account/'
    | '/user/discounts/'
    | '/user/home/'
    | '/user/orders/'
    | '/user/payment-methods/'
    | '/user/referral/'
    | '/user/store/'
    | '/user/subscription/'
    | '/user/subscription/box/edit'
    | '/user/subscription/box/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AIAssistantRoute: typeof AIAssistantRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  HomeRoute: typeof HomeRoute
  LiRoute: typeof LiRoute
  LoginPageRoute: typeof LoginPageRoute
  MenuRoute: typeof MenuRoute
  PlanRoute: typeof PlanRoute
  PrRoute: typeof PrRoute
  RcheckoutRoute: typeof RcheckoutRoute
  RegisterRoute: typeof RegisterRouteWithChildren
  SuccessPageRoute: typeof SuccessPageRoute
  UserRoute: typeof UserRouteWithChildren
  RReferralCodeRoute: typeof RReferralCodeRoute
  partnershipsActivacionesLazyRoute: typeof partnershipsActivacionesLazyRoute
  partnershipsCyberLazyRoute: typeof partnershipsCyberLazyRoute
  partnershipsPluxeeLazyRoute: typeof partnershipsPluxeeLazyRoute
  RegisternewBetaLazyRoute: typeof RegisternewBetaLazyRoute
  LoginIndexLazyRoute: typeof LoginIndexLazyRoute
  LogoutIndexLazyRoute: typeof LogoutIndexLazyRoute
  informationPrivacyPolicyIndexLazyRoute: typeof informationPrivacyPolicyIndexLazyRoute
  informationTermsAndConditionsIndexLazyRoute: typeof informationTermsAndConditionsIndexLazyRoute
  partnershipsCajaLosAndesIndexLazyRoute: typeof partnershipsCajaLosAndesIndexLazyRoute
  partnershipsEnergyClubIndexLazyRoute: typeof partnershipsEnergyClubIndexLazyRoute
  partnershipsEntelIndexLazyRoute: typeof partnershipsEntelIndexLazyRoute
  partnershipsFenUchileIndexLazyRoute: typeof partnershipsFenUchileIndexLazyRoute
  partnershipsLoBarnecheaIndexLazyRoute: typeof partnershipsLoBarnecheaIndexLazyRoute
  partnershipsTarjetaMiVitaIndexLazyRoute: typeof partnershipsTarjetaMiVitaIndexLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AIAssistantRoute: AIAssistantRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  HomeRoute: HomeRoute,
  LiRoute: LiRoute,
  LoginPageRoute: LoginPageRoute,
  MenuRoute: MenuRoute,
  PlanRoute: PlanRoute,
  PrRoute: PrRoute,
  RcheckoutRoute: RcheckoutRoute,
  RegisterRoute: RegisterRouteWithChildren,
  SuccessPageRoute: SuccessPageRoute,
  UserRoute: UserRouteWithChildren,
  RReferralCodeRoute: RReferralCodeRoute,
  partnershipsActivacionesLazyRoute: partnershipsActivacionesLazyRoute,
  partnershipsCyberLazyRoute: partnershipsCyberLazyRoute,
  partnershipsPluxeeLazyRoute: partnershipsPluxeeLazyRoute,
  RegisternewBetaLazyRoute: RegisternewBetaLazyRoute,
  LoginIndexLazyRoute: LoginIndexLazyRoute,
  LogoutIndexLazyRoute: LogoutIndexLazyRoute,
  informationPrivacyPolicyIndexLazyRoute:
    informationPrivacyPolicyIndexLazyRoute,
  informationTermsAndConditionsIndexLazyRoute:
    informationTermsAndConditionsIndexLazyRoute,
  partnershipsCajaLosAndesIndexLazyRoute:
    partnershipsCajaLosAndesIndexLazyRoute,
  partnershipsEnergyClubIndexLazyRoute: partnershipsEnergyClubIndexLazyRoute,
  partnershipsEntelIndexLazyRoute: partnershipsEntelIndexLazyRoute,
  partnershipsFenUchileIndexLazyRoute: partnershipsFenUchileIndexLazyRoute,
  partnershipsLoBarnecheaIndexLazyRoute: partnershipsLoBarnecheaIndexLazyRoute,
  partnershipsTarjetaMiVitaIndexLazyRoute:
    partnershipsTarjetaMiVitaIndexLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/AIAssistant",
        "/forgot-password",
        "/home",
        "/li",
        "/loginPage",
        "/menu",
        "/plan",
        "/pr",
        "/rcheckout",
        "/register",
        "/successPage",
        "/user",
        "/r/$referralCode",
        "/(partnerships)/activaciones",
        "/(partnerships)/cyber",
        "/(partnerships)/pluxee",
        "/register_new/beta",
        "/login/",
        "/logout/",
        "/(information)/privacy-policy/",
        "/(information)/terms-and-conditions/",
        "/(partnerships)/caja-los-andes/",
        "/(partnerships)/energy-club/",
        "/(partnerships)/entel/",
        "/(partnerships)/fen-uchile/",
        "/(partnerships)/lo-barnechea/",
        "/(partnerships)/tarjeta-mi-vita/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/AIAssistant": {
      "filePath": "AIAssistant.tsx"
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/home": {
      "filePath": "home.tsx"
    },
    "/li": {
      "filePath": "li.tsx"
    },
    "/loginPage": {
      "filePath": "loginPage.tsx"
    },
    "/menu": {
      "filePath": "menu.tsx"
    },
    "/plan": {
      "filePath": "plan.tsx"
    },
    "/pr": {
      "filePath": "pr.tsx"
    },
    "/rcheckout": {
      "filePath": "rcheckout.tsx"
    },
    "/register": {
      "filePath": "register.tsx",
      "children": [
        "/register/confirmation",
        "/register/shipping-frecuency",
        "/register/shipping-methods",
        "/register/subscriptions",
        "/register/success",
        "/register/user-data"
      ]
    },
    "/successPage": {
      "filePath": "successPage.tsx"
    },
    "/user": {
      "filePath": "user.tsx",
      "children": [
        "/user/preferences",
        "/user/shipping/edit",
        "/user/subscription/edit",
        "/user/account/",
        "/user/discounts/",
        "/user/home/",
        "/user/orders/",
        "/user/payment-methods/",
        "/user/referral/",
        "/user/store/",
        "/user/subscription/",
        "/user/subscription/box/edit",
        "/user/subscription/box/"
      ]
    },
    "/r/$referralCode": {
      "filePath": "r/$referralCode.tsx"
    },
    "/register/confirmation": {
      "filePath": "register/confirmation.tsx",
      "parent": "/register"
    },
    "/register/shipping-frecuency": {
      "filePath": "register/shipping-frecuency.tsx",
      "parent": "/register"
    },
    "/register/shipping-methods": {
      "filePath": "register/shipping-methods.tsx",
      "parent": "/register"
    },
    "/register/subscriptions": {
      "filePath": "register/subscriptions.tsx",
      "parent": "/register"
    },
    "/register/success": {
      "filePath": "register/success.tsx",
      "parent": "/register"
    },
    "/register/user-data": {
      "filePath": "register/user-data.tsx",
      "parent": "/register"
    },
    "/user/preferences": {
      "filePath": "user/preferences.tsx",
      "parent": "/user"
    },
    "/(partnerships)/activaciones": {
      "filePath": "(partnerships)/activaciones.lazy.tsx"
    },
    "/(partnerships)/cyber": {
      "filePath": "(partnerships)/cyber.lazy.tsx"
    },
    "/(partnerships)/pluxee": {
      "filePath": "(partnerships)/pluxee.lazy.tsx"
    },
    "/register_new/beta": {
      "filePath": "register_new/beta.lazy.tsx"
    },
    "/login/": {
      "filePath": "login/index.lazy.tsx"
    },
    "/logout/": {
      "filePath": "logout/index.lazy.tsx"
    },
    "/user/shipping/edit": {
      "filePath": "user/shipping/edit.tsx",
      "parent": "/user"
    },
    "/user/subscription/edit": {
      "filePath": "user/subscription/edit.tsx",
      "parent": "/user"
    },
    "/(information)/privacy-policy/": {
      "filePath": "(information)/privacy-policy/index.lazy.tsx"
    },
    "/(information)/terms-and-conditions/": {
      "filePath": "(information)/terms-and-conditions/index.lazy.tsx"
    },
    "/(partnerships)/caja-los-andes/": {
      "filePath": "(partnerships)/caja-los-andes/index.lazy.tsx"
    },
    "/(partnerships)/energy-club/": {
      "filePath": "(partnerships)/energy-club/index.lazy.tsx"
    },
    "/(partnerships)/entel/": {
      "filePath": "(partnerships)/entel/index.lazy.tsx"
    },
    "/(partnerships)/fen-uchile/": {
      "filePath": "(partnerships)/fen-uchile/index.lazy.tsx"
    },
    "/(partnerships)/lo-barnechea/": {
      "filePath": "(partnerships)/lo-barnechea/index.lazy.tsx"
    },
    "/(partnerships)/tarjeta-mi-vita/": {
      "filePath": "(partnerships)/tarjeta-mi-vita/index.lazy.tsx"
    },
    "/user/account/": {
      "filePath": "user/account/index.lazy.tsx",
      "parent": "/user"
    },
    "/user/discounts/": {
      "filePath": "user/discounts/index.lazy.tsx",
      "parent": "/user"
    },
    "/user/home/": {
      "filePath": "user/home/index.lazy.tsx",
      "parent": "/user"
    },
    "/user/orders/": {
      "filePath": "user/orders/index.lazy.tsx",
      "parent": "/user"
    },
    "/user/payment-methods/": {
      "filePath": "user/payment-methods/index.lazy.tsx",
      "parent": "/user"
    },
    "/user/referral/": {
      "filePath": "user/referral/index.lazy.tsx",
      "parent": "/user"
    },
    "/user/store/": {
      "filePath": "user/store/index.lazy.tsx",
      "parent": "/user"
    },
    "/user/subscription/": {
      "filePath": "user/subscription/index.lazy.tsx",
      "parent": "/user"
    },
    "/user/subscription/box/edit": {
      "filePath": "user/subscription/box/edit.lazy.tsx",
      "parent": "/user"
    },
    "/user/subscription/box/": {
      "filePath": "user/subscription/box/index.lazy.tsx",
      "parent": "/user"
    }
  }
}
ROUTE_MANIFEST_END */
